import React from 'react';

const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_demo-arvanta/artifacts/1ljd19ky_Arvanta_Solutions.png';

export const Logo = ({ size = 36 }) => (
  <img
    src={LOGO_URL}
    width={size}
    height={size}
    alt="Arvanta Solutions"
    style={{ width: size, height: size, objectFit: 'contain' }}
    className="select-none"
    draggable={false}
  />
);

export default Logo;
